import { render } from "./DashBoard.vue?vue&type=template&id=177bccbc"
import script from "./DashBoard.vue?vue&type=script&lang=js"
export * from "./DashBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__